import React from "react";
export default function Title({ name }) {
  return (
    <div className="w-full uppercase">
      <h3 className="text-2xl md:text-3xl leading-tight font-extrabold tracking-tight text-kj-ink">
        <span className="underline underline-offset-[6px] decoration-kj-gold decoration-2">
          {name}
        </span>
      </h3>
    </div>
  );
}
